import React, { useEffect } from 'react'
import { compose } from 'recompose'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Warning from '@material-ui/icons/Warning'
import Typography from '@material-ui/core/Typography'
import Button from '../../../components/Button'
import StyledWrapper from '../../../components/StyledWrapper'
import { withRouter } from 'react-router'

import { connect } from 'react-redux'
import Logo from '../../../assets/logo'
import history from '../../../utilties/history'
import { injectIntl } from 'react-intl'
import { errorCodeSelector } from '../../../redux/selectors'
import { resetErrorCode } from '../../../redux/actions'

const Error = ({
	intl,
	errorCode,
	resetErrorCode
}) => {
	return (
		<StyledWrapper hideMenu={true}>
			<Paper style={{ maxWidth: '479px', width: '90%', padding: '4rem', position: 'absolute', top: 'calc(50% - 20px)', left: '50%', transform: 'translate(-50%, -50%)' }} elevation={2}>
				<Grid item style={{ paddingBottom: '20px', textAlign: 'center' }}>
					<Logo />
				</Grid>
				{errorCode && <Grid item container style={{ paddingBottom: '20px', textAlign: 'center', 'justify-content': 'center' }}>
					<Warning style={{ fontSize: '20px', 'margin-right': '8px' }} />
					<Typography
						style={{
							'font-size': '18px',
							'font-stretch': 'normal',
							'font-style': 'normal',
							'line-height': 'normal',
							'letter-spacing': '0.23px',
							'text-align': 'center',
							'text-transform': 'uppercase'
						}}>
						{intl.formatMessage({ id: `app.error.n.${errorCode}` })}
					</Typography>
				</Grid>}
				<Grid item style={{ paddingTop: '20px', textAlign: 'center' }}>
					<Button
						textId='app.error.button'
						variant='contained'
						color='primary'
						type='submit'
						onClick={() => {
							resetErrorCode()
							history.push(`/`);
						}}
					/>
				</Grid>
			</Paper>

		</StyledWrapper>
	)
}

const mapStateToProps = (state, ownProps) => ({
	errorCode: errorCodeSelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	resetErrorCode: () => dispatch(resetErrorCode())
})

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	injectIntl,
	withRouter
)

export default enhance(Error)
